var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({ref:"cont",staticClass:"sizer-container",style:({
		width: _vm.sizeVal(_vm.width),
		maxWidth: _vm.sizeVal(_vm.maxWidth),
	})},'div',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"sizer-elm",style:({ paddingBottom: (_vm.ratioPct + "%") })}),_c('img',{ref:"image",class:( _obj = { wider: _vm.wider, taller: !_vm.wider }, _obj[_vm.imgClass] = true, _obj[_vm.alignClass] = true, _obj ),attrs:{"alt":_vm.alt,"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }